<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <base-card title="Import Saldo Stockist">
        <form class="space-y-4" @submit.prevent="onProcess">
          <base-input
            ref="inputFile"
            label="Pilih File"
            fullwidth
            :shadow="false"
            type="file"
            accept=".csv"
            size="padding-md"
            required
            @change="onChangeFile"
          />
          <base-button type="submit" :loading="loadingProcess.visible">{{
            loadingProcess.visible ? loadingProcessLabel : 'Proses'
          }}</base-button>
        </form>
      </base-card>

      <base-card title="Keterangan">
        <dl class="grid gap-4">
          <div class="w-full">
            <dt class="text-sm text-gray-900">
              Contoh file import saldo stockist (.csv)
            </dt>
            <dd class="mt-1">
              <a
                href="/import-saldo-example/saldo-stockist.csv"
                class="text-sm font-medium text-green-600"
                >saldo-stockist.csv</a
              >
            </dd>
          </div>
        </dl>
      </base-card>

      <datatable
        :total="histories.meta.page.total"
        :perPage="histories.meta.page.perPage"
        :currentPage="histories.meta.page.currentPage"
        :columns="[
          { id: 'date', name: 'Tanggal' },
          { id: 'status', name: 'Status', theadClass: 'text-center' },
          { id: 'download', name: 'Download File', theadClass: 'text-center' },
          { id: 'download_error', name: 'Download Error', theadClass: 'text-center' },
        ]"
        @pagechanged="onChangeHistoryPage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="history in histories.data"
            :key="history.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">
              {{ history.attributes.createdAt | formatDate }}
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge
                v-if="history.attributes.status === 'queued'"
                color="yellow"
                >Menunggu Diproses</base-badge
              >
              <base-badge
                v-else-if="history.attributes.status === 'processing'"
                color="blue"
                >Sedang Diproses</base-badge
              >
              <base-badge
                v-else-if="
                  history.attributes.status === 'failed'
                "
                color="red"
                >Gagal</base-badge
              >
              <base-badge
                v-else-if="
                  history.attributes.failed_file_url
                "
                color="red"
                >Selesai dengan Error</base-badge
              >
              <base-badge v-else color="green">Selesai</base-badge>
            </td>
            <td :class="[classes.td, 'text-center']">
              <a
                v-if="history.attributes.file_url"
                :href="history.attributes.file_url"
                class="flex justify-center text-green-600"
              >
                <icon icon="heroicons:arrow-down-tray" class="h-4 w-4" />
              </a>
            </td>
            <td :class="[classes.td, 'text-center']">
              <a
                v-if="history.attributes.failed_file_url"
                :href="history.attributes.failed_file_url"
                class="flex justify-center text-green-600"
              >
                <icon icon="heroicons:arrow-down-tray" class="h-4 w-4" />
              </a>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters, mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  data() {
    return {
      file: null,
      loadingPage: false,
      loadingProcess: {
        visible: false,
        text: null,
      },
      histories: {
        data: [],
        meta: {
          page: {},
        },
      },
      chunk: {
        total: 0,
        completed: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    loading() {
      return this.loadingPage;
    },
    loadingProcessLabel() {
      if (this.loadingProcess.text === 'processing') {
        return `Memproses ${Math.floor(this.chunk.completed/this.chunk.total * 100)}%`
      }

      return {
        wait: 'Mengirim Data',
        queued: 'Menunggu Diproses',
        processing: 'Sedang Diproses',
      }[this.loadingProcess.text];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onProgress
      );
    },
    async loadImportHistories(params) {
      this.loadingPage = true;

      const [res, err] = await this.request(
        '/api/v1/import-office-balance-histories',
        {
          params: {
            'page[size]': 5,
            sort: '-id',
            'filter[office_type]': 'import_stockist_balance',
            ...params,
          },
        }
      );

      if (!err) {
        const running = res.data.some(
          (history) => !history.attributes.finished
        );

        if (running) {
          const history = res.data.find(history => !history.attributes.finished)

          this.chunk.completed = history.attributes.completed_chunk 
          this.chunk.total = history.attributes.total_chunk

          this.startLoadingProcess(res.data[0].attributes.status);
        }

        this.histories = res;
      }

      this.loadingPage = false;
    },
    onProgress(e) {
      if (e.type === 'App\\Notifications\\OfficeBalanceImportStatusUpdated') {
        if (e.status === 'processing') {
          this.startLoadingProcess('processing');
        } else if (e.status === 'chunking') {
          this.chunk.completed = e.completed_chunk
        } else if (e.status === 'failed') {
          this.stopLoadingProcess();

          this.createAlert({
            status: 'error',
            data: e.message,
          });
        } else if (e.status === 'finished') {
          this.stopLoadingProcess();

          this.createAlert({
            status: 'success',
            data: 'Berhasil mengimport saldo stockist',
          });

          this.loadImportHistories()

          this.file = null
          this.$refs.inputFile.$refs.input.value = null
        }
      }
    },
    onChangeFile(e) {
      this.file = e.target.files[0];
    },
    async onProcess() {
      this.startLoadingProcess('wait');

      const formData = new FormData();

      formData.append('file', this.file);

      const [res, err] = await this.request(
        '/api/v1/offices/-actions/import-saldo-stockist',
        {
          method: 'post',
          data: formData,
        }
      );

      if (!err) {
        this.startLoadingProcess('queued');

        this.chunk.total = res.total_chunk;
        this.chunk.completed = 0;
      } else {
        this.stopLoadingProcess();

        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      }
    },
    onChangeHistoryPage(page) {
      this.loadImportHistories({
        'page[number]': page,
      });
    },
    removeListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onProgress
        );
      }
    },
    startLoadingProcess(text) {
      this.loadingProcess.text = text;
      this.loadingProcess.visible = true;
    },
    stopLoadingProcess() {
      this.loadingProcess.visible = false;
    },
  },
  created() {
    this.loadImportHistories();
    this.addListener();
  },
  beforeRouteLeave(to, from, next) {
    this.removeListener();
    next();
  },
};
</script>
